import React from 'react'
import pageMargins from 'src/components/styles/snippets/pageMargins'
import classnames from 'classnames'
import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'

const useStyles = makeStyles<Theme, BasePageProps>(
  (theme) => ({
    root: ({ width }) => ({
      ...pageMargins(theme, width),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        paddingTop: 15
      }
    })
  }),
  { name: 'BasePage' }
)

export interface BasePageProps {
  className?: string
  children?: React.ReactNode
  width?: 'xl'
  classes?: StyleClasses<typeof useStyles>
}

const BasePage = (props: BasePageProps) => {
  const classes = useStyles(props)

  return <div className={classnames(classes.root, props.className)}>{props.children}</div>
}

export default BasePage
